/* Native Shopify forms handle all payments/cart writes. No keys or Lulu API calls here. */
(() => {
  'use strict';
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const section = select.closest('[data-product-section]');
    const option = select.options[select.selectedIndex];
    const price = section.querySelector('[data-variant-price]');
    if (price) price.textContent = option.dataset.price || '';
    const add = section.querySelector('[data-add-button]');
    if (add) { const available = option.dataset.available === 'true'; add.disabled = !available; add.textContent = available ? 'Add to book bag' : 'Sold out'; }
    const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-product-image]');
    if (button) {
      const section = button.closest('[data-product-section]');
      const image = section.querySelector('.main-product-image');
      if (image) { image.removeAttribute('srcset'); image.src = button.dataset.productImage; image.alt = button.dataset.imageAlt || ''; }
    }
    if (event.target.closest('.mobile-panel a')) document.querySelectorAll('.mobile-menu').forEach(menu => menu.open = false);
  });
})();
